interface WorkExperiences {
  id: string
  industryTags: []
  financialTags: []
  softwareTags: []
}

interface ExternalProjects {
  id: string
  industryTags: []
  financialTags: []
  softwareTags: []
}

export const retrieveTagsFromEntities = (
  tagTypes: string,
  expertTags: [],
  workExperiences: [WorkExperiences],
  externalProjects: [ExternalProjects],
) => {
  const workExperiencesTags = workExperiences.flatMap((tag) => tag[tagTypes])
  const externalProjectsTags = externalProjects.flatMap((tag) => tag[tagTypes])
  const mergedTags = workExperiencesTags.concat(externalProjectsTags, expertTags)

  const tagArray = Array.from(new Set(mergedTags))

  return tagArray
}
